<template src="./detail.html"></template>

<script>

import TopService from 'Services/TopService';

export default {
  data() {
    return {
      top: {},
    };
  },

  created() {
    this.listSlideBars();
  },

  methods: {
    listSlideBars() {
      TopService.show(this.$route.params.id)
        .then((response) => {
          this.top = response.data;
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
pre {
     text-align: justify;
     white-space: pre-line;
}
</style>
